import { ShopOutlined } from "@ant-design/icons";
import { SellerIcon } from "@/components/icon";
import type { OperatorBadge } from "./people-filter.types";

/** El ícono de tipo de afiliación — store o seller — que usan el chip de `OperatorsFilter` y
 * cualquier otro lugar que necesite mostrar una afiliación de operador (ej. el popover de
 * "Filtros aplicados" del dashboard, xcons-docs#312). */
export const AffiliationIcon = ({
  type,
  color,
}: {
  type: OperatorBadge["type"];
  color: string;
}) =>
  type === "store" ? (
    <ShopOutlined style={{ fontSize: 11, color }} />
  ) : (
    <SellerIcon style={{ fontSize: 11, color }} />
  );
